import type { Draft } from '~publish/legacy/composer/composer/entities/Draft'

// The draft's first comment (`channelData.<service>.comment_text`) for the
// GraphQL `firstComment` metadata field. Empty → `undefined` so create omits
// the field; edit-time clearing is `clearable`'s job.
export function getFirstComment(draft: Draft): string | undefined {
  return draft.getCommentText() || undefined
}
